import { Box, styled } from '@mui/material'
import { mobile } from '../../utils/breakpoints'
import { HEADER_HEIGHT } from '../../theme'

export const HeaderContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  justify-items: center;
  overflow: visible;
  position: relative;
`

export const HeaderLogoContainer = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  justify-items: center;
  background-color: ${({ theme }) => theme.palette.branding.headerBackground};
  height: ${HEADER_HEIGHT.desktop};
  position: relative;
  z-index: 1;

  ${({ theme }) => mobile(theme, { height: HEADER_HEIGHT.mobile })}
`
